import { render, staticRenderFns } from "./live.vue?vue&type=template&id=9d4bb9f8&scoped=true&"
import script from "./live.vue?vue&type=script&lang=ts&"
export * from "./live.vue?vue&type=script&lang=ts&"
import style0 from "./live.vue?vue&type=style&index=0&id=9d4bb9f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4bb9f8",
  null
  
)

export default component.exports